import { Link } from "react-router-dom";
import React from "react";
import { BRAND } from 'utils/Helper';

class Logo extends React.Component {
  render() {
    return (
      <>
        <div className="topbar-left">
          <Link to="/" className="logo">
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '-4px' }} >
            </div>
          </Link>
        </div>
      </>
    );
  }
}

export default Logo;
